import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M24.7,15.71v10c0,.82-.48,1.52-1.05,1.52H8.35c-.57,0-1-.7-1-1.52V6.25c0-.82.48-1.52,1-1.52h6.82V3.43H8.35A2.61,2.61,0,0,0,6,6.25v19.5a2.61,2.61,0,0,0,2.35,2.82h15.3A2.61,2.61,0,0,0,26,25.75v-10Z' }),
  React.createElement('path', { d: 'M12.37,24.59h1.3a18.28,18.28,0,0,1,7.09-15l1.89,3.33a.68.68,0,0,0,.57.33h.08a.65.65,0,0,0,.55-.47l1.67-6.11a.61.61,0,0,0-.06-.49.67.67,0,0,0-.39-.31L19,4.19a.66.66,0,0,0-.74.95l1.89,3.31A19.52,19.52,0,0,0,12.37,24.59ZM24.1,7l-1.09,4-2.88-5Z' })
));